import { useTranslation } from 'react-i18next';
import { Skeleton } from '@mui/material';
import searchIcon from 'assets/images/icons/search.svg';
import { PresetsModel } from 'app/general-settings/model/general-settings.model';
import ITSVG from '../ITSVG';

export const getStoredTableDefaultRowsPerPage = () => {
  let rowPerPage = 30;
  const savedDataAsString = localStorage.getItem('appPresets');
  if (savedDataAsString) {
    const savedData: PresetsModel = JSON.parse(savedDataAsString);
    if (savedData.tableDefaultRowsPerPage > 0) {
      rowPerPage = savedData.tableDefaultRowsPerPage;
    }
  }

  return rowPerPage;
}

const defaultRowsPerPage = getStoredTableDefaultRowsPerPage();
const paginationRowsPerPageOptions = [10, 20, 30, 50, 100];

const TableHeader = (handleSearch: any) => {
  const { t } = useTranslation();
  return (
    <div className="card-title mb-8 d-flex justify-content-between">
      <div className="d-flex align-items-center position-relative my-1">
        <ITSVG path={searchIcon} className={'svg-icon-1 position-absolute ms-6'} />
        <input
          type="text"
          className="form-control form-control-solid w-250px ps-14"
          placeholder={`${t('searchInput.placeholder')}`}
          name="searchInput"
          onChange={handleSearch}
        />
      </div>
    </div>
  );
};

function PaginationComponentOptions() {
  const { t } = useTranslation();
  const paginationComponentOptions = {
    rowsPerPageText: `${t('datatable.pagination.title')}`,
    rangeSeparatorText: t('datatable.pagination.of'),
    selectAllRowsItem: true,
    selectAllRowsItemText: t('datatable.selectedItems.all'),
  };

  return paginationComponentOptions;
}

function ContextMessage() {
  const { t } = useTranslation();
  const contextMessage = {
    singular: `${t('datatable.selectedItems.singular')}`,
    plural: `${t('datatable.selectedItems.plural')}`,
  };

  return contextMessage;
}

function NoDataComponent() {
  const { t } = useTranslation();
  return (
    <div className="text-gray-600 fw-bolder my-10">
      <div className="d-flex text-center w-100 align-content-center justify-content-center">
        {t('datatable.noData')}
      </div>
    </div>
  );
}

function Loader() {
  return (
    <div className="w-100 overflow-hidden">
      <div className="row">
        <div className="col">
          <Skeleton variant="rounded" height={25} className="my-2" />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Skeleton variant="rounded" height={25} className="my-2" />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Skeleton variant="rounded" height={25} className="my-2" />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Skeleton variant="rounded" height={25} className="my-2" />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Skeleton variant="rounded" height={25} className="my-2" />
        </div>
      </div>
    </div>
  );
}

export const tableHelper = {
  TableHeader: TableHeader,
  PaginationComponentOptions: PaginationComponentOptions,
  ContextMessage: ContextMessage,
  NoDataComponent: NoDataComponent,
  Loader: Loader,
  defaultRowsPerPage,
  paginationRowsPerPageOptions
};
